import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    ContratorBuses:[],
    CaptainsBus:[],
  },
  getters: {
    getContratorBuses(state) {
      return state.ContratorBuses;
    },
    getCaptainsBus(state) {
      return state.CaptainsBus;
    },
  },
  mutations: {
    SetContratorBuses(state, data) {
      state.ContratorBuses = [];
      state.ContratorBuses = data;
    },
    SetCaptainsBus(state, data) {
      state.CaptainsBus = [];
      state.CaptainsBus = data;
    }
  },
  actions: {
    getBusesForContractorById({ commit }) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `ContractorDetails/getBusesForContractorById`,
          {},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
                      resolve(res);

          commit("SetContratorBuses", res.data);
        })
        .catch((err) => console.log(err));});
    },
    getCaptainsBusByBusId({ commit },id) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `ContractorDetails/getCaptainsBusByBusId`,
          {id:id},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
                      resolve(res);

          commit("SetCaptainsBus", res.data);
        })
        .catch((err) => console.log(err));});
    },
  },
};
